var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{style:(`min-height:${_vm.chartMinHeight};`)},[_c('base-chart',{ref:"analysisChart",attrs:{"id":"analysis-chart","domId":"analysis-chart","loading":_vm.loading,"chartData":_vm.chartData,"chartConfig":_vm.chartConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }